import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=5d36d8bb&"
import script from "./SystemMessage.vue?vue&type=script&lang=js&"
export * from "./SystemMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d36d8bb')) {
      api.createRecord('5d36d8bb', component.options)
    } else {
      api.reload('5d36d8bb', component.options)
    }
    module.hot.accept("./SystemMessage.vue?vue&type=template&id=5d36d8bb&", function () {
      api.rerender('5d36d8bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Information/SystemMessage.vue"
export default component.exports